import SessionsDetailModal from './SessionsDetailModal';
import SessionsDetailModalDataDisplay from './SessionsDetailModalDataDisplay';
import SessionsDetailModalTitle from './SessionsDetailModalTitle';
import SessionsDetailModalInvitees from './SessionsDetailModalInvitees';
import SessionsDetailModalSectionTitle from './SessionsDetailModalSectionTitle';
import SessionsDetailModalDeleteSettings from './SessionsDetailModalDeleteSettings';
import SessionsDetailModalModerator from './SessionsDetailModalModerator';

SessionsDetailModal.DataDisplay = SessionsDetailModalDataDisplay;
SessionsDetailModal.Title = SessionsDetailModalTitle;
SessionsDetailModal.Invitees = SessionsDetailModalInvitees;
SessionsDetailModal.SectionTitle = SessionsDetailModalSectionTitle;
SessionsDetailModal.DeleteSettings = SessionsDetailModalDeleteSettings;
SessionsDetailModal.Moderator = SessionsDetailModalModerator;

export {
  SessionsDetailModalDataDisplay as DataDisplay,
  SessionsDetailModalTitle as Title,
  SessionsDetailModalInvitees as Invitees,
  SessionsDetailModalSectionTitle as SectionTitle,
  SessionsDetailModalDeleteSettings as DeleteSettings,
  SessionsDetailModalModerator as Moderator,
};

export default SessionsDetailModal;
